export default __webpack_public_path__ + "assets/009d9347583156141dcf54c6fda8f692.png";